export default __webpack_public_path__ + "static/media/designVersions.ad6f4c25.svg";